export enum LevelingAction {
  ManualSelection = 'manualSelection',
  PlacementTest = 'placementTest',
  ProgressTestBanner = 'progressTestBanner',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/leveling-action.ts